import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PrivateMessageView from 'components/pages/PrivateMessage';
import { setActiveSubMenuItem } from 'containers/store';

import {
  onSubmit,
  onCancel,
  loadPageData,
} from './store';

class PrivateMessageContainer extends React.Component {
  static propTypes = {
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveSubMenuItem: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.loadPageData();
    this.props.setActiveSubMenuItem('sendMessage');
  }

  render() {
    return this.props.isLoadedPage ? (
      <PrivateMessageView {...this.props} />
    ) : null;
  }
}

const mapDispatchToProps = {
  onSubmit,
  onCancel,
  setActiveSubMenuItem,
  loadPageData,
};

const mapStateToProps = (state) => ({
  ...state.PrivateMessage,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivateMessageContainer);
